export default "__VITE_ASSET__BRciO2_a__"